import { Routes } from '@angular/router';
import { DrillsRoutes } from '@core';
import { DrillCreateComponent, DrillDetailComponent, DrillEditComponent, DrillsListComponent } from './components';

export const DrillsRouting: Routes = [
  { path: DrillsRoutes.ROOT, component: DrillsListComponent },
  { path: DrillsRoutes.CREATE, component: DrillCreateComponent },
  { path: `${DrillsRoutes.DETAIL}/:id`, component: DrillDetailComponent },
  { path: `${DrillsRoutes.EDIT}/:id`, component: DrillEditComponent }
];
